const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        accidentCostUnit: 'Kostenträger',
        accidentDate: 'Unfall- /Rückfalldatum',
        accidentNoNumber: 'Keine Angabe zur Schadennummer vorhanden',
        accidentNumber: 'Schadennummer',
        additionalAmbulant: 'Haben Sie eine Zusatzversicherung für ambulante Behandlungen?',
        additionalAmbulantName: 'Name der Zusatzversicherung',
        additionalInsurance: 'Zusatz-Versicherung?',
        additionalInsuranceFlex: 'Flex-Versicherung',
        additionalInsuranceName: 'Zusatzversicherung (VVG)',
        additionalInsuranceNo: 'Policen-Nr.',
        ahv: 'AHV-Nr.',
        assignment: 'Einweisung durch',
        behandlungsgrund: 'Behandlungsgrund',
        civilStatus: 'Zivilstand',
        class: 'Versicherungsklasse',
        company: 'Arbeitgeber',
        correspondenceAddress: 'Abweichende Korrespondenzadresse',
        costsAndConsentCheckbox:
            'Der Patient/die Patientin ist einverstanden, dass das Universitätsspital medizinische Daten elektronisch oder in Papierform an nachbehandelnde Ärzte und Institutionen (Spitäler, Rehakliniken) weitergibt (bitte ankreuzen).',
        costsAndConsentText:
            'Kostenübernahme <br>Sie schulden dem Universitätsspital Zürich die Kosten, die weder von der Versicherung noch vom Wohnkanton getragen werden, z. B. bei fehlender Versicherungsdeckung aufgrund von Ausschlüssen wie vorbestehenden Krankheiten, Substanzmissbrauch oder Karenzfristen. Das USZ unterstützt Sie bei der Abrechnung mit den kostentragenden Einrichtungen.',
        dateOfBirth: 'Geburtstag',
        einwArzt: 'Einweisender Arzt',
        hausArzt: 'Hausarzt / Hausärztin',
        hometown: 'Heimatort',
        insuranceCardNo: 'Versicherungskarten-Nr.',
        insuranceName: 'Name der Versicherung',
        insurancePolicyNo: 'Policen-/Kunden-Nr.',
        insuranceText:
            'Upgrade der Behandlungskategorie<br><br>Auf Wunsch können Sie auf eigene Kosten eine über die Versicherungsdeckung hinausgehende Behandlungskategorie wählen (Upgrade). Stimmen Sie sich dazu mit der zuständigen Klinik ab. Die Anzahlung dafür ist fünf Tage vor Spitaleintritt fällig. Die Preise sind in der Taxordnung des Universitätsspitals Zürich festgehalten.',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        keinHausarzt: 'Ich habe keinen Hausarzt / Hausärztin',
        kontakt: 'Kontaktperson / Angehörige',
        kosten: 'Kostenübernahme und Einverständnis',
        nationality: 'Nationalität',
        noEmail: 'Ich habe keine E-Mail-Adresse',
        noEmailText: 'Die Rechnung wird per Post versendet.',
        noMarketing:
            'E-Mail und Mobilnummer werden für die Terminerinnerung und den gesetzlich vorgeschriebenen Versand der Rechnungskopie gebraucht. Sie werden nicht zu Marketingzwecken genutzt.',
        persAngaben: 'Persönliche Angaben',
        persAngabenInfoText:
            'Das Universitätsspital arbeitet mit dem Bundestool und der Vorname, sowie Nachname werden direkt aus diesem Datensystem übernommen. Individuelle Anpassungen sind leider nicht möglich.',
        privacyPolicyCheckbox: 'Ich habe die {link} gelesen und stimme dieser zu.',
        privacyPolicyLink: 'Datenschutzerklärung',
        profession: 'Beruf',
        relation: 'Verwandtschaftsgrad',
        religion: 'Religion',
        versicherungLabel: 'Versicherung',
    },
    __RELATIVE_SOURCE_FILE__
);
